import FollowUpView from './FollowUpView';

export default FollowUpView;